export const GOOGLE_PLAY_APP = "https://play.google.com/store/apps/details?id=com.sabeqoon.lms.sabeqoon";
export const APP_STORE_APP = "https://apps.apple.com/app/sabeqoon/id6744279929";
export const CONTACT_EMAIL_1 = "support@sabeqoon.com";
export const CONTACT_EMAIL_2 = "schools@sabeqoon.com";
export const SUPPORTED_LANGUAGES = ["en", "ar", "tr"];
export const FALLBACK_LANGUAGE = "en";
